import { CommonModule, DatePipe } from '@angular/common';
import { HttpClient, HttpEvent, HttpEventType } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { catchError, map, timeout } from 'rxjs/operators';
import { MainService } from '../main.service';
import { environment } from 'src/environments/environment';
import { CompressImageService } from '../compress-image.service';
import { SharedService } from '../shared.service';
import { ApiService } from '../api.service';
import { SharedModule } from '../shared.module';
import { FormsModule } from '@angular/forms';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';

@Component({
  selector: 'app-csr-request-modal',
  templateUrl: './csr-request-modal.component.html',
  styleUrls: ['./csr-request-modal.component.scss'],
})
export class CsrRequestModalComponent implements OnInit {
  id: any;
  type: any;
  statusClosed = false;
  public data: any = {};
  notes: any = {};
  assigned_id: any;
  minDate!: Date;
  note: any;

  images: any = [];
  selectedFile: any;
  uploading!: boolean;
  fileSubscription: any[] = [];
  imageURLs: any = [];
  fileProgress: any = [];
  @ViewChild('imageElement')
  imgElement!: ElementRef;
  timezoneName: any = localStorage.getItem('timezoneName');
  public currentTimezone = localStorage.getItem('timezone');
  hours = [
    { value: '00' },
    { value: '01' },
    { value: '02' },
    { value: '03' },
    { value: '04' },
    { value: '05' },
    { value: '06' },
    { value: '07' },
    { value: '08' },
    { value: '09' },
    { value: '10' },
    { value: '11' },
    { value: '12' },
    { value: '13' },
    { value: '14' },
    { value: '15' },
    { value: '16' },
    { value: '17' },
    { value: '18' },
    { value: '19' },
    { value: '20' },
    { value: '21' },
    { value: '22' },
    { value: '23' },
  ];
  minutes = [
    { value: '00' },
    { value: '15' },
    { value: '30' },
    { value: '45' },
  ];
  formData: any;
  user_id: any;
  dispute_detail_id: any;
  dispute_id: any;
  bsConfig = {
    showWeekNumbers: false,
    dateInputFormat: 'MM-DD-YYYY',
    selectFromOtherMonth: true,
  };
  constructor(
    public bsModalRef: BsModalRef,
    public mainService: MainService,
    private datePipe: DatePipe,
    private _sanitizer: DomSanitizer,
    private _http: HttpClient,
    private compressImage: CompressImageService,
    public _shared: SharedService,
    public _api: ApiService
  ) {}

  ngOnInit() {
    this.minDate = new Date();
    this.minDate.setHours(0, 0, 0, 0);
    this.notes['followup_date'] = this.minDate;
    this.notes.followup_hour = null;
    this.notes.followup_minutes = null;
    this.notes.status = '0';
    console.log(this.data.assign_type, 'checking assign type');

    switch (this.data.assign_type) {
      case 1:
        if (this.data.csr_requests) {
        }
        break;
      case 2:
        break;
      case 3:
        break;
      case 4:
        if (this.data.csr_notes) {
        }
        break;
    }
  }

  hideModal() {
    this.bsModalRef.hide();
  }

  onChangeStatus(status: any) {
    if (status.target.value == 2) {
      this.statusClosed = true;
    } else {
      this.statusClosed = false;
    }
  }

  handleAddNotes() {
    let note: any = {
      note: this.note,
      source_type: this.notes.source_type,
      contact_request_type: this.notes.contact_request_type,
      assigned_id: this.notes.assigned_id,
      followup_date: this.datePipe.transform(
        this.notes.followup_date,
        'yyyy-MM-dd'
      ),
      customer_feedback: this.notes.customer_feedback,
      priority: this.notes.priority,
      status: 1,
      is_dummy: 1,
    };
    // 62 User CSR Request 9 Microloan CSR Request 2 Request CSR Request 1 Offer CSR Request
    if (this.data.assign_type == 1) {
      note['user_id'] = this.id;
      note['action_type'] = 62;
    }
    if (this.data.assign_type == 2) {
      note['microloan_id'] = this.id;
      note['user_id'] = this.user_id;
      note['action_type'] = 9;
    }
    if (this.data.assign_type == 3) {
      note['request_id'] = this.id;
      note['user_id'] = this.user_id;
      note['action_type'] = 2;
    }
    if (this.data.assign_type == 4) {
      note['offer_id'] = this.id;
      note['user_id'] = this.user_id;
      note['action_type'] = 1;
    }
    if (this.images && this.images.length > 0) {
      note['docs_urls'] = this.images.map((x: any) => x.image);
    }
    if (this.uploading) {
      this._shared.customPopups('Please wait while files are uploading', 2);
      return false;
    }
    if (
      this.notes.status != 2 &&
      (!this.notes.followup_hour || !this.notes.followup_minutes)
    ) {
      this._shared.customPopups('Please select a valid followup time', 2);
      return false;
    }

    if (!this.note || this.note.trim().length == 0) {
      this._shared.customPopups('Please enter a valid note', 2);
      return false;
    }
    if (this.notes.followup_hour && this.notes.followup_minutes) {
      let time = new Date().getTimezoneOffset();
      let hours = Math.abs(Math.trunc(time / 60));
      let minutes = ('0' + (time % 60)).slice(-2);
      let user_timezone = '';
      if (time > 0) {
        user_timezone = '-' + hours + minutes;
      } else {
        user_timezone = '+' + hours + minutes;
      }
      let today_time = this._shared.getfollowupDateTimeInUTCToday(
        new Date(),
        user_timezone
      );
      let today_time_1 = new Date(today_time).getTime();
      let follow_up = this._shared.getfollowupDateTimeInUTC(
        note.followup_date +
          ` ${this.notes.followup_hour}:${this.notes.followup_minutes}:00`,
        this.currentTimezone
      );
      let follow_up_time = new Date(follow_up).getTime();
      if (!this.statusClosed && today_time_1 >= follow_up_time) {
        this._shared.customPopups('Please select future time for followup', 2);
        return false;
      } else {
        note.followup_date = follow_up;
      }
    }

    if (!this.notes.assigned_id) {
      this._shared.customPopups('Please select send request to option', 2);
      return false;
    }
    this._api.api(note, 'add_csr_request', 'object').subscribe(
      (data: any) => {
        if (data.is_error == 0) {
          this.bsModalRef.hide();
          this.mainService.noteadded = true;
          this._shared.customPopups(data.msg, data.is_error);
        }
      },
      (error: any) => {
        console.log(error);
      }
    );

    return false;
  }

  selectMood(mood: any) {
    if (mood == 1) {
      this.notes.customer_feedback = 1;
    } else if (mood == 2) {
      this.notes.customer_feedback = 2;
    }
  }

  onAdminSelect(event: any) {
    this.notes.assigned_id = event.item.admin_id;
  }

  selectAdmin(event: any) {
    this.notes.assigned_id = event;
  }

  adminClear(event: any) {
    if (event.length == 0) {
      this.notes.assigned_id = '';
    }
  }

  fileSelect(event: any) {
    if (this.images && this.images.length > 9) {
      this._shared.customPopups('Can not upload more than 10 files', 2);
      return false;
    }
    if (
      event &&
      event.target &&
      event.target.files &&
      event.target.files.length > 0
    ) {
      for (let file of event.target.files) {
        let timestamp = new Date().getTime();
        let splitFileName = event.target.files[0].name.split('.');
        const updatedFile = new File(
          [event.target.files[0]],
          splitFileName[0] + `_${timestamp}.${splitFileName[1]}`,
          { type: file.type }
        );
        let selectedFile = { file: updatedFile };
        console.log(
          `Image size before compressed: ${selectedFile.file.size} bytes.`
        );
        this.compressImage
          .compress(selectedFile.file)
          // .pipe(take(1))
          .subscribe((compressedImage: any) => {
            console.log(
              `Image size after compressed: ${compressedImage.size} bytes.`
            );
            selectedFile.file = compressedImage;
            ///////
          });
        if (
          (selectedFile.file.type.indexOf('image/') === 0 &&
            selectedFile.file.type != 'image/gif') ||
          selectedFile.file.type.indexOf('application/') === 0
        ) {
          let index = this.images.findIndex(
            (x: any) => x.file.mediaFile.name == selectedFile.file.name
          );
          const reader = this.readFiles(selectedFile);
          if (index < 0) {
            this.images.push({ file: reader });
            this.uploadFile(reader, this.images.length - 1, event);
            this.imgElement.nativeElement.value = '';
          }
        } else {
          this._shared.customPopups('Please select valid file', 2);
        }
      }
    }
    return false;
  }

  readFiles(file: any) {
    file.mediaFile = file.file;
    file.file = this._sanitizer.bypassSecurityTrustResourceUrl(
      URL.createObjectURL(file.mediaFile)
    );
    return file;
  }

  uploadFile(item: any, index?: any, ev?: any) {
    this.uploading = true;
    this.images[index].uploading = true;
    const formData = new FormData();
    formData.append('file', item.mediaFile);
    this.images[index].uploadSub = this._http
      .post(environment.baseUrl + `upload_csr_doc`, formData, {
        reportProgress: true,
        observe: 'events',
      })
      .pipe(
        map((event: HttpEvent<any>) => {
          let response: any = [];
          if (event.type === HttpEventType.UploadProgress) {
            const percentDone = Math.round(
              (100 * event.loaded) / (event && event.total ? event.total : 0)
            );
            response.push({ status: 'progress', message: percentDone });
          }
          if (event.type === HttpEventType.Response) {
            response.push(event.body);
          }
          return response;
        })
      )
      .subscribe((d) => {
        this.images[index].subs = d;
        this.fileSubscription = d;
        let success = d.every((item: any) => {
          return item.status != 'progress';
        });
        if (success) {
          this.uploading = false;
          this.images[index].uploading = false;
          d.forEach((item: any) => {
            this.imageURLs.push(item.images[0]);
            this.images[index].image = item.images[0];
          });
          ev.target.value = '';
        } else {
          this.uploading = true;
          this.images[index].uploading = true;
        }
      });
  }
  deletFile(file: any, index: any) {
    this._api
      .api({ url: file }, `delete_hard_request_doc`, 'post')
      .subscribe((data: any) => {
        if (data && data.is_error == 0) {
          this.images.splice(index, 1);
        }
      });
  }

  cancelImageUpload(file: any, index: any) {
    this.images[index].uploadSub.unsubscribe();
    this.images[index].uploading = false;
    this.images.splice(index, 1);
    this.images.every((item: any) => (this.uploading = item.uploading));
  }
}
